// Question copy is authored as English source strings, natural-key style, so a
// placeholder is both the key and the fallback. These options stop i18next from
// reading "e.g. site.com/terms" as a namespace/key path and make the string itself the
// default, which is what every question placeholder in the schema relies on.
export const tLiteral = (t, text) =>
  text ? t(text, { nsSeparator: false, keySeparator: false, defaultValue: text }) : undefined
